module.exports = __webpack_public_path__ + "static/media/bgmainslider.6db58a0b.png";